import React from 'react';
import { Icon } from 'antd';

export const LCIcon = props => <Icon {...props} />;
